// extracted by mini-css-extract-plugin
module.exports = {"View":"View_View__TrwLr"};